import Reflux from "reflux";

import { updateJobPage, getJobPage } from "./JobPageService";

const INIT = {
  updateJobPage: { asyncResult: true },
  getJobPage: { asyncResult: true },
  resetJobPage: { asyncResult: true }
};

const Actions = Reflux.createActions(INIT);

Actions.updateJobPage.listen(function (campaignId, jobPageData) {
  updateJobPage({ campaignId, jobPageData }).then(this.completed).catch(this.failed);
});

Actions.getJobPage.listen(function (campaignId) {
  getJobPage(campaignId).then(this.completed).catch(this.failed);
});

export default Actions;
